//import * as d3 from 'd3';  // npm install d3 or yarn add d3
import * as f3 from 'family-chart';  // npm install family-chart@0.9.0 or yarn add family-chart@0.9.0
import 'family-chart/styles/family-chart.css';

/**
 * ============================================
 * Family Chart Adapter — JEFA Tree JSON → Rows
 * ============================================
 *
 * Purpose:
 * Convert the nested tree JSON returned by:
 *   GET /lineages/:id/tree_json
 *
 * into the flat "rows" structure required by the
 * `family-chart` library.
 *
 * --------------------------------------------
 * INPUT (Rails JSON shape)
 * --------------------------------------------
 *
 * A recursive object starting at `payload.node`:
 *
 * {
 *   id: 108,
 *   display_name: "Michelle Hartley",
 *   gender: "F",
 *   birth_date_text: "...",
 *   birth_place: "...",
 *   parents: {
 *     father: {
 *       relationship_type: "bio",
 *       node: { ...same shape... }
 *     },
 *     mother: {
 *       relationship_type: "bio",
 *       node: { ...same shape... }
 *     }
 *   }
 * }
 *
 * --------------------------------------------
 * OUTPUT (family-chart rows)
 * --------------------------------------------
 *
 * Array of nodes:
 *
 * [
 *   {
 *     id: "108",
 *     data: {
 *       id: "108",
 *       gender: "F",
 *       "first name": "Michelle",
 *       "last name": "Hartley",
 *       "birthday": "...",
 *       "birth place": "...",
 *       "deathday": "..."
 *     },
 *     rels: {
 *       parents: ["109", "142"]
 *     }
 *   }
 * ]
 *
 * --------------------------------------------
 * WHAT THIS FUNCTION DOES
 * --------------------------------------------
 *
 * 1. Recursively walks the nested tree
 * 2. Flattens nodes into a single array
 * 3. Converts parent relationships into ID references
 * 4. Splits display_name into first/last name
 * 5. Normalizes missing values for safe rendering
 *
 * --------------------------------------------
 * IMPORTANT NOTES
 * --------------------------------------------
 *
 * - This is NOT part of the family-chart library.
 *   It is custom glue code for JEFA.
 *
 * - Family Chart REQUIRES:
 *     - flat array of nodes
 *     - string IDs
 *     - relationship references by ID
 *
 * - If tree_json structure changes,
 *   THIS FUNCTION must be updated.
 *
 * --------------------------------------------
 * DEBUGGING TIPS
 * --------------------------------------------
 *
 * If the chart renders incorrectly:
 *
 * - console.log(rows) to inspect output
 * - ensure IDs are strings (not integers)
 * - ensure parent IDs exist in the array
 * - check gender is present ("M", "F", or "U")
 *
 */


document.addEventListener("turbo:load", initFamilyTree)

// function initFamilyTree() {
//   const el = document.getElementById("FamilyTree")
//   if (!el) return

//   mountFamilyTree(el)
// }
function initFamilyTree() {
  const el = document.getElementById("FamilyTree")
  if (!el) return

  if (el.dataset.familyTreeMounted === "true") {
    console.log("[family-tree] already mounted")
    return
  }

  el.dataset.familyTreeMounted = "true"

  mountFamilyTree(el)
}

async function mountFamilyTree(el) {
  const lineageId = el.dataset.lineageId
  const depth = el.dataset.depth || 3

  try {
    const res = await fetch(`/lineages/${lineageId}/tree_json?depth=${depth}`)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)

    const payload = await res.json()

    // 👇 THIS IS YOUR EXISTING FUNCTION
    const rows = adaptTreeToFamilyTree(payload.node)

    const chart = f3.createChart("#FamilyTree", rows)
      .setTransitionTime(500)
      .setCardXSpacing(250)
      .setCardYSpacing(150)

    chart.setCardHtml()
      .setCardDisplay([
        ["first name", "last name"],
        ["birthday"],
        ["birth place"]
      ])

    chart.updateTree({ initial: true })

  } catch (e) {
    console.error("[family-tree] error:", e)
  }
}

function adaptTreeToFamilyTree(node, rows = [], seen = new Set()) {
  if (!node || seen.has(String(node.id))) return rows

  seen.add(String(node.id))

  const father = node.parents?.father?.node
  const mother = node.parents?.mother?.node
  const parentIds = [father?.id, mother?.id].filter(Boolean).map(String)

  const fullName = node.display_name || `Person #${node.id}`
  const parts = fullName.trim().split(/\s+/)
  const lastName = parts.length > 1 ? parts.pop() : ""
  const firstName = parts.join(" ") || fullName

  rows.push({
    id: String(node.id),
    data: {
      "gender": node.gender || "U",// temporary fallback until you map real gender
      "first name": firstName,
      "last name": lastName,
      "birthday": node.life_dates || ""
    },
    rels: parentIds.length ? { parents: parentIds } : {}
  })

  if (father) adaptTreeToFamilyTree(father, rows, seen)
  if (mother) adaptTreeToFamilyTree(mother, rows, seen)

  return rows
}



